'use strict'
/**
 * progressSummary.js — Contrato PROGRESS "Tus partes" (OPERACIÓN PIEL · F2).
 *
 * EL BUG QUE TIPA: la pestaña "Tus 7 partes" renderizaba 5 cards EN BLANCO
 * (solo chevron) — tres vocabularios implícitos chocando:
 *   · balance360.axes usa { id: 'training_load'... } (5 ejes · radar)
 *   · las cards leían axis.key (¡no existe!) → icono/label undefined
 *   · domain_deltas/limiting_domain usan las claves del vector Prime
 *     ('entrenamiento'...'cronobiologia' · 7)
 * Superficie nunca tipada — no estaba entre los 8 contratos del MACRO 1.
 *
 * PRODUCTOR: src/routes/progressRoutes.js · GET /api/progress/c5/:userId/summary
 * CONSUMIDOR: ProgressV2Page · PartesTab (cards desde domain_deltas ·
 *             radar desde balance360)
 */

const { z } = require('./z')

/** Eje del radar ahora-vs-día1 (escala 0-100 · 5 ejes del balance360Calculator) */
const Balance360AxisSchema = z
  .object({
    id: z.string().min(1),
    label: z.string().min(1),
    optimal_min: z.number(),
    optimal_max: z.number(),
    current: z.number().nullable(),
    day1: z.number().nullable(),
  })
  .passthrough()

/** Delta por dominio del vector Prime (escala 0-10) */
const DomainDeltaSchema = z
  .object({
    current: z.number(),
    // COLA:progreso-cae-por-contrato-tras-331 · sin puntuación anterior con la misma fuente no hay delta ni day1 (deltasMismaFuente): null, no un fallo
    day1: z.number().nullable(),
    delta: z.number().nullable(),
  })
  .passthrough()

/** Lo que la pestaña "Tus partes" consume del summary */
const ProgressPartesSchema = z
  .object({
    balance360: z
      .object({ axes: z.array(Balance360AxisSchema) })
      .passthrough()
      .nullable()
      .optional(),
    domain_deltas: z.record(z.string(), DomainDeltaSchema).optional(),
    limiting_domain: z.string().nullable().optional(),
    top_growth_domain: z.string().nullable().optional(),
  })
  .passthrough()

// ── Las partes del vector · ORDEN CANÓNICO ───────────────────────────────────
// ⚠️ DECISIÓN ABIERTA (Javier): doctrina dice "vector de 8 dimensiones", el
// vector real tiene 7 claves y el copy de prod dice "Tus 7 partes". Este es
// EL ÚNICO SITIO que define el número y el orden — el veredicto 7v8 se
// aplica aquí y cae en cascada (copy incluido vía PARTES_COUNT).
const PARTES_ORDER = Object.freeze([
  'entrenamiento', 'nutricion', 'movilidad', 'sueno', 'recuperacion',
  'mental', 'cronobiologia',
])
const PARTES_COUNT = PARTES_ORDER.length
const PARTES_SECONDARY = Object.freeze(new Set(['mental', 'cronobiologia']))

module.exports = {
  Balance360AxisSchema,
  DomainDeltaSchema,
  ProgressPartesSchema,
  PARTES_ORDER,
  PARTES_COUNT,
  PARTES_SECONDARY,
}
